'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MAX_LIST_DEPTH = exports.MAX_LIST_DEPTH = 5;

var INLINE_STYLES = exports.INLINE_STYLES = [{ label: 'Bold', style: 'BOLD' }, { label: 'Italic', style: 'ITALIC' }, { label: 'Underline', style: 'UNDERLINE' }, { label: 'Monospace', style: 'CODE' }];

var BLOCK_TYPES = exports.BLOCK_TYPES = [{ label: 'H1', style: 'header-one' }, { label: 'H2', style: 'header-two' }, { label: 'H3', style: 'header-three' }, { label: 'H4', style: 'header-four' }, { label: 'H5', style: 'header-five' }, { label: 'H6', style: 'header-six' }, { label: 'Blockquote', style: 'blockquote' }, { label: 'UL', style: 'unordered-list-item' }, { label: 'OL', style: 'ordered-list-item' }, { label: 'Code', style: 'code-block' }, { label: 'Paragraph', style: 'unstyled' }];


/*****************
 ** WEBPACK FOOTER
 ** ../~/draft-js-richbuttons-plugin/lib/config/types.js
 ** module id = 600
 ** module chunks = 0
 **/